import {hrmsWithPath} from "../../services/http/api/rest";

const rest = hrmsWithPath('/v1/');

const leave = {

    admin: {},
    request: {
        list: (data?: any, pageNumber?: number, pageSize?: number) => rest.post('leave-request/search', {}, data, {
            "page-number": pageNumber,
            "page-size": pageSize,
        }),
        getAudit: (id: string) => rest.get('leave-request/{{id}}/audit', {id}),
        create: (data: any) => rest.post("leave-request", {}, data),
        delete: (id: string) => rest.del('leave-request/{{id}}', {id}),
        approve: (id: string) => rest.put('leave-request/{{id}}/approve',
            {
                id
            }, {}),
        reject: (id: string, reason: string) => rest.put('leave-request/{{id}}/reject',
            {
                id
            }, {}, {reason}),
        cancel: (id: string, reason: string) => rest.put(`leave-request/{{id}}/cancel`, {id}, { },{reason}),
        getReporteesLeaves: (pageNumber?: number, pageSize?: number) => rest.get('leave-request/reportees', {}, {
            "page-number": pageNumber,
            "page-size": pageSize,
        })
    },
    type: {
        create: (data: any) => rest.post('leave-type', {}, data),
        list: () => rest.get('leave-type/all', {}),
        delete: (id: string) => rest.del('leave-type/{{id}}', {id},),
        updateStatus: (status: boolean, id: string) => rest.put('leave-type/{{id}}', {id}, undefined, {active: status}),
    },
    balance: {
        get: (id: string) => rest.get('leave-balance/leave-period/{{id}}', {id}),
        search: (data: any, pageNumber: number, pageSize: number) => rest.post('leave-balance/search', {}, data, {
            "page-number": pageNumber,
            "page-size": pageSize
        }),
        getById: (data: any) => rest.post('leave-balance/search', {}, data, {}),
    },
    period: {
        list: () => rest.get('leave-period/find', {}, {}),
        create: (data: any) => rest.post('leave-period', {}, data, {}),
        delete: (id: string) => rest.del('leave-period/{{id}}', {id}),
        update: (id: string, data: any) => rest.put(`leave-period/{{id}}`, {id}, data),
        updateStatus: (id: string, active: boolean) => rest.put('leave-period/mark-active/{{id}}', {id}, {}, {active: active})
    },
    entitlement: {
        list: (
            pageNumber?: number,
            pageSize?: number,
            leavePeriodId?: string,
            sortField?: string,
            sortDirection?: "ASC" | "DESC"
        ) =>
            rest.get(
                "leave-entitlement/search",
                {},
                {
                    "leave-period-id": leavePeriodId,
                    "page-number": pageNumber,
                    "page-size": pageSize,
                    "sort-by": sortField,
                    "sort-direction": sortDirection
                }
            ),
        create: (data: any) => rest.post("leave-entitlement", {}, data),
        delete: (id: string) => rest.del('leave-entitlement/{{id}}', {id},),
        update: (id: string, data: any) => rest.put('leave-entitlement/{{id}}', {id}, data, {}),
        getAudit: (id: string) => rest.get('leave-entitlement/{{id}}/audit', {id}),
        bulkAssignReview: (body: any) => rest.post('leave-entitlement/bulk-assign-review', {}, body, {}),
        bulkEntitlementAssign: (body: any) => rest.post('leave-entitlement/bulk-assign', {}, body, {}),
    },
    leaveSummary: {
        list: (leavePeriodId: string) => rest.get("leave-request/count", {}, {"leave-period-id": leavePeriodId})
    }
}

export default leave;
